module.exports = __webpack_public_path__ + "static/cv-Valeriya-Kozlova-en-bfd0ace99a89d9f0e3bfc322f09f631e.pdf";